import { handleActions } from 'redux-actions';
import { EditorState } from '../types';
import { switchTab } from '../actions/extension-emote';

export default handleActions<EditorState['extensionEmote'], any>(
  {
    [`${switchTab}`]: (state, action: ReturnType<typeof switchTab>) => ({
      ...state,
      selectorSection: action.payload.tab,
    }),
  },
  {
    selectorSection: 'emoji',
  }
);
